/* eslint-disable */
import { ArrowDownIcon } from "@radix-ui/react-icons";
import "./overviewSummaryCard.scss";
import { LoadGauge } from "utils/helper";

const OverviewSummaryCard = (props) => {
  const {
    cardTitle,
    maxMinAvg,
    cardType,
    filteredData,
    fullData,
    sessionFilter,
  } = props;

  // !!! make sure thata the progressComparisonBar is working properly speak with the group on monday and see what the desired output is.


  const percentageDifference = (num1, num2) => {
    // const difference = num1 - num2;
    // const average = (num1 + num2) / 2;
    // const percentDifference = (difference / average) * 100;
    // return percentDifference.toFixed(1);


    //num 1 / num 2 * 100
    const numsDiveded = num1 / num2

    const percentageOf = numsDiveded * 100
    
    return percentageOf.toFixed(1);
  };


  const isPercentageHigher =
    percentageDifference(filteredData?.total, fullData?.total) >= 100
      ? true
      : false;

  return (
    <div className="overview_summary_card_container">
      <div className="overview_summary_card_heading">
        <h4>{`${cardType === "progressComparisonBar" ? maxMinAvg.charAt(0).toUpperCase() + maxMinAvg.slice(1) +" ": ""}`}{cardTitle}</h4>
      </div>
      <div className="overview_summary_card_metric_values">
        {/* Load --------------------------------------------------------------*/}
        {cardType === "load" ? (
          <div className="overview_summary_card_values">
            <div className="card_metric_value">
              {filteredData?.total?.toFixed(2)}
            </div>
            {Number(
              percentageDifference(filteredData?.total, fullData?.total)
            ) !== 100 ? (
              <div className="card_metric_percentage_diff">
                {Number(
                  percentageDifference(filteredData?.total, fullData?.total)
                ) !== 0 ? (
                  <div
                    className={`${
                      isPercentageHigher ? "arrow-higher" : "arrow-lower"
                    }`}
                  >
                    <ArrowDownIcon />
                  </div>
                ) : null}
                {Number(
                  percentageDifference(filteredData?.total, fullData?.total)
                ) > 0
                  ? Number(
                      percentageDifference(filteredData?.total, fullData?.total)
                    )
                  : Number(
                      percentageDifference(filteredData?.total, fullData?.total)
                    ) * -1}
                %
              </div>
            ) : (
              <div className="card_metric_percentage_diff">Equal</div>
            )}
            <div className="card_metric_timeline_operation">
              {`${
                Number(
                  percentageDifference(filteredData?.total, fullData?.total)
                ) === 100 || Number(
                  percentageDifference(filteredData?.total, fullData?.total)
                ) < 100
                  ? Number(
                    percentageDifference(filteredData?.total, fullData?.total)
                  ) !== 100 ?  "of" : "to"
                  : "of"
              } 
              ${"all-time"} 
              ${maxMinAvg}`}
            </div>
          </div>
        ) : null}
        {cardType === "load" ? (
          <div className="overview_summary_card_metric">
            <LoadGauge
              leftValue={filteredData?.leftValue}
              rightValue={filteredData?.rightValue}
            />
          </div>
        ) : null}

        {/* Asymmetry --------------------------------------------------------------*/}
        {cardType === "asymmetry" ? (
          <div className="overview_summary_card_values">
            <div className="card_metric_value">
              {
               ( ((filteredData?.leftValue - filteredData?.rightValue) /2 ) > 0 ? 
                ((filteredData?.leftValue - filteredData?.rightValue) /2 ) : 
                ((filteredData?.leftValue - filteredData?.rightValue) /2 )*-1)?.toFixed(2)
            
              } %
            </div>

            <div className={`card_metric_percentage_diff ${(filteredData?.leftValue - filteredData?.rightValue) / 2 > 0 ? "left_color" : "right_color"}`}>{`${(filteredData?.leftValue - filteredData?.rightValue) / 2 > 0 ? "Left" : "Right"}`}</div>

            <div className="card_metric_timeline_operation">{`foot`}</div>
          </div>
        ) : null}
        {cardType === "asymmetry" ? (
          <div className="overview_summary_card_metric">
            <LoadGauge
              leftValue={filteredData?.leftValue}
              rightValue={filteredData?.rightValue}
              percentageDifference={true}
            />
          </div>
        ) : null}

         {/* Asymmetry --------------------------------------------------------------*/}
         {cardType === "progressComparisonBar" ? (
          <div className="overview_summary_card_values">
            <div className="card_metric_value">
              {
            
                filteredData?.total?.toFixed(2)
            
              }
            </div>

            <div className={`card_metric_percentage_diff`}>{`${(filteredData?.total / (fullData?.total/100)).toFixed(2)}%`}</div>

            <div className="card_metric_timeline_operation">{`of all-time ${maxMinAvg}`}</div>
          </div>
        ) : null}
        {cardType === "progressComparisonBar" ? (
          <div className="overview_summary_card_metric">
            <LoadGauge
              maxValue={fullData?.total}
              comparedValue={filteredData?.total}
              progressBar={true}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default OverviewSummaryCard;
